import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'estudio-resumen-barra',
    template: `
        <div class="header-mainInfo">
            <a class="control-item" href="/estudio" title="Ir a estudio">Estudio</a><span
                class="header-mainInfo__separator">/</span>
            <h1 class="">Resumen</h1>
        </div>`,
    standalone: false
})

export class EstudioResumenBarraComponent implements OnInit {
    constructor() {
    }

    ngOnInit() {
    }
}
